module.exports = __webpack_public_path__ + "img/left.31317005.svg";